import {forwardRef, useEffect, useImperativeHandle, useState} from 'react'
import Lottie from 'lottie-react'
import * as animationData from '@assets/lotties/mic.json'
import micIcon from '@assets/svgs/mic.svg'
import {Button, Flex} from '@chakra-ui/react'
import {useRecord} from '@hooks/useRecord'

function ExamMic(
  {onRecordingComplete, countdownTimerRef, setIsShowCountDown}: any,
  ref: any,
) {
  const [isRecording, recordingBlob, startRecording, stopRecording] =
    useRecord()
  const [isDisabled, setIsDisabled] = useState<boolean>(true)

  const handlePressMic = () => {
    if (isRecording) {
      setIsDisabled(true)
      setIsShowCountDown(false)
      countdownTimerRef.current?.pauseTimer()
      stopRecording()
    } else {
      setIsDisabled(false)
      setIsShowCountDown(true)
      countdownTimerRef.current?.startTimer()
      startRecording()
    }
  }

  const handleEnableMic = () => {
    setIsDisabled(false)
  }

  const getMicStatus = () => {
    return isRecording
  }

  useImperativeHandle(
    ref,
    () => ({
      handlePressMic,
      handleEnableMic,
      getMicStatus,
    }),
    [handlePressMic, handleEnableMic, getMicStatus],
  )

  useEffect(() => {
    if (!recordingBlob) return
    onRecordingComplete(recordingBlob)
    // recordingBlob will be present at this point after 'stopRecording' has been called
  }, [recordingBlob])

  return (
    <Flex justifyContent={'center'}>
      <Button
        id="exam-mic"
        isDisabled={isDisabled}
        w={140}
        h={70}
        borderRadius={50}
        onClick={handlePressMic}
        _disabled={{bg: '#CCCCCC'}}
        _hover={{
          bgGradient: isDisabled
            ? '#CCCCCC'
            : isRecording
              ? 'orangered'
              : 'linear(to-t, #07D2FF, #00A3FF)',
        }}
        bgGradient={
          isRecording
            ? 'linear(to-b, #FFA800, #FFC34F)'
            : 'linear(to-b, #07D2FF, #00A3FF)'
        }
        bgColor={isRecording ? 'orangered' : '#00A3FF'}>
        {isRecording ? (
          <Lottie animationData={animationData} />
        ) : (
          <img alt={'mic'} src={micIcon} />
        )}
      </Button>
    </Flex>
  )
}

export default forwardRef(ExamMic)
